<template>
  <div id="main_div">
    <OfferMain/>
    <SalesPoint/>
    <Screenshots/>
    <Store/>
    <Advantages/>
    <StepsGetStarted/>
    <Feedback/>
    <RecallForm/>
    <Map/>
    <!-- Footer Section start -->
    <Footer/>
    <!-- Footer Section End -->
    <js/>
  </div>
</template>
<script>
export default {
  name: 'Company',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
<!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->



// WEBPACK FOOTER //
// src/pages/offer_page.vue